// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';
import { Auth } from '@supabase/auth-ui-react';
import {
  ThemeSupa,
} from '@supabase/auth-ui-shared';
import './Login.css';
import logo from '../../../assets/ControllaVoiceLogo.png';
import styled from 'styled-components/macro';
import { Jelly } from '@uiball/loaders';
import {Box} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/pro-solid-svg-icons";
import { serverUrl } from "app/constants";
import {SignIn, useSession} from "@clerk/clerk-react";

function Login() {
  const { isLoaded, isSignedIn, session } = useSession()
  const navigate = useNavigate();

  if (!isLoaded) {
    return (
      <div style={{ height: '100vh', width: '100vw', display: 'flex' }}>
        <div style={{ margin: 'auto' }}>
          <Jelly size={120} speed={3} color="#ff74e9" />
        </div>
      </div>
    );
  } else {
    if (session) {
      return  <Navigate to="/app/welcome" />;
    }
  }


  // let authComponent = (
  //     <Auth
  //         supabaseClient={supabase}
  //         appearance={{ theme: ThemeSupa }}
  //         providers={['google']}
  //         redirectTo={serverUrl + "/login"}
  //     />
  // );

  let authComponent = <SignIn />


  return (
    <div className="login">
      <div className="login__container">
        <Logo>
          <img src={logo} />
        </Logo>
        <Disclaimer> We are currently upgrading our services, please contact hello@controlla.xyz if you have trouble accessing your account </Disclaimer>
        {/*<Tagline> Sign in for early access to the world's highest quality AI singing voices </Tagline>*/}
        {authComponent}
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'stretch', alignItems: 'center', fontSize: '14px', marginLeft: '10px', marginBottom: '0px' }}>
          <FontAwesomeIcon icon={faLock} size={"2x"}/>
          <Disclaimer> Your voice model is only accessible to you  </Disclaimer>
        </Box>
        <Terms>
          <a href="https://controlla.notion.site/Controlla-Voice-Terms-of-Use-29ab0cc02f614042873151574b54cae7?pvs=4">Terms of Use</a>
        </Terms>
      </div>
    </div>
  );
}

const Logo = styled.div`
  max-height: 180px;
  max-width: 300px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  padding-right: 20px;
  
  margin-right: auto;
  margin-left: auto;
  
  & img {
    max-width:100%;
    max-height: 100%;
  }
`;

const Tagline = styled.p`
  max-width: 300px;
  font-size: 18px;
`;

const Disclaimer = styled.p`
  max-width: 300px;
  font-size: 14px;
  margin-left: auto;
  margin-right: auto;
`;

const Terms = styled.div`
  margin: 0px;
  padding: 0px;
  a {
    font-size: 14px;
    color: #ff74e9;
    margin: 0px;
    padding: 0px;
  }
`

export default Login;
